module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Regular.eot
// module id = 581
// module chunks = 57